import { Stack, styled as muiStyled } from '@mui/material';

export const StyledLogoContainer = muiStyled(Stack, {
  shouldForwardProp: (prop) => prop !== 'setLength',
})<{ setLength: boolean }>`
  svg {
    width:  ${({ setLength }) => (setLength ? '150px' : 'auto')}
  }
`;
